export function toggleUnsupportedBrowser() {
  return {
    type: "UNSUPPORTEDBROWSER",
    payload: true,
  };
}
